// #515 — a guest taps a bout bell. The bell needs an account, so the prompt
// offers the notifications guide or the sign-in. #552: the shared GuestPrompt
// draws it, as it draws the #263 "Register Boxers" prompt.
import GuestPrompt from '../shared/GuestPrompt';
import { useI18n } from '../../i18n';

export default function GuestBellPrompt({ onClose }: { onClose: () => void }) {
  const { t } = useI18n();
  return (
    <GuestPrompt
      title={t.common.guestBellTitle}
      text={t.common.guestBellText}
      guideHref="/manual#notifications"
      guideLabel={t.common.guestBellGuide}
      onClose={onClose}
    />
  );
}
